import React from 'react';
import styled from 'styled-components';
import { useLanguage } from '../contexts/LanguageContext';

const HeroContainer = styled.div`
  position: relative;
  height: 100vh;
  width: 100%;
  overflow: hidden;
  background: url('/images/HOMEFULLPAGE.webp') center center/cover;
  @media (max-width: 968px) {
    background: url('/images/Valerie_Keith/Lino Ludovic - Wedding photographer - Annecy - Savoie (22).webp') center center/cover;
  }
`;

const Center = styled.div`
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
`;

const DiscoverBtn = styled.button`
  pointer-events: auto;
  background: rgba(103, 49, 58, 0.4); /* brown at 40% opacity */
  color: #ffffff;
  border: 1px solid rgba(103, 49, 58, 0.6);
  padding: 10px 26px;
  font-family: 'Montserrat', sans-serif;
  font-size: 12px;
  letter-spacing: 2px;
  text-transform: uppercase;
  border-radius: 2px;
  cursor: pointer;
  transition: all 0.25s ease;
  margin-top: 90px; /* a few pixels lower than exact center */

  &:hover {
    background: rgba(103, 49, 58, 0.5);
  }
`;

const Hero = () => {
  const { lang } = useLanguage();

  const handleDiscover = (e) => {
    e.preventDefault();
    const el = document.getElementById('discover');
    if (el) {
      const header = document.getElementById('site-header');
      const headerHeight = header ? header.offsetHeight : 0;
      const y = el.getBoundingClientRect().top + window.scrollY - headerHeight - 6;
      window.scrollTo({ top: y, behavior: 'smooth' });
    } else {
      window.scrollTo({ top: window.innerHeight, behavior: 'smooth' });
    }
  };

  return (
    <HeroContainer>
      <Center>
        <DiscoverBtn onClick={handleDiscover}>{lang === 'fr' ? 'Découvrir' : 'Discover'}</DiscoverBtn>
      </Center>
    </HeroContainer>
  );
};

export default Hero;
